import React, { useEffect, useContext } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom"; // Agregué useLocation para saber en qué pagina estamos
import { AuthContext } from '../contexts/AuthContext';
import '../stylesheets/header.css';

function Header() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation(); // Para saber la ruta actual

  const getNavLinkClasses = (path) => (
    location.pathname === path
      ? 'header__nav-link header__nav-link--active'
      : 'header__nav-link'
  );

  const closeMobileMenu = () => {
    const navbar = document.getElementById('navbar');
    const mobileToggle = document.querySelector('.mobile-nav-toggle');
    if (navbar?.classList.contains('navbar-mobile')) {
      navbar.classList.remove('navbar-mobile');
      mobileToggle?.classList.remove('bi-x');
      mobileToggle?.classList.add('bi-list');
    }
  };

  const handleNavLinkClick = () => {
    closeMobileMenu();
  };

  useEffect(() => {
    // Mantenemos tu lógica original del menú móvil y scroll
    const navbar = document.getElementById('navbar');

    const handleMobileNavToggle = (e) => {
      navbar.classList.toggle('navbar-mobile');
      e.target.classList.toggle('bi-list');
      e.target.classList.toggle('bi-x');
    };

    const handleDropdownClick = (e) => {
      if (navbar.classList.contains('navbar-mobile')) {
        e.preventDefault();
        e.target.nextElementSibling?.classList.toggle('dropdown-active');
      }
    };

    const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
    if (mobileNavToggle) {
      mobileNavToggle.addEventListener('click', handleMobileNavToggle);
    }

    const dropdownLinks = document.querySelectorAll('.navbar .dropdown > a');
    if (dropdownLinks) {
      dropdownLinks.forEach(item => {
        item.addEventListener('click', handleDropdownClick, true);
      });
    }

    return () => {
      if (mobileNavToggle) mobileNavToggle.removeEventListener('click', handleMobileNavToggle);
      if (dropdownLinks) dropdownLinks.forEach(item => item.removeEventListener('click', handleDropdownClick, true));
    };
  }, []);

  const handleLogout = (e) => {
    e.preventDefault();
    closeMobileMenu();
    logout();
    navigate('/');
  };

  return (
    <header className='header'>
      <div className='header__container'>
        <div className='header--logo'>
          <Link to='/'>
            {/* Asegúrate de que la ruta de la imagen sea correcta */}
            <img className='header--image' src={require('../img/logo.png')} alt="Logo" />
          </Link>
        </div>
        
        <nav id="navbar" className="navbar">
          <ul> 
            {/* ENLACE HOME */}
            <li>
              <Link 
                to='/' 
                className={getNavLinkClasses('/')}
                onClick={handleNavLinkClick}
              >
                Home
              </Link>
            </li>
            
            {/* ENLACE CONEXIONES (Visible solo si hay usuario) */}
            {user && (
              <li>
                <Link 
                  to='/conexiones'
                  className={getNavLinkClasses('/conexiones/')}
                  onClick={handleNavLinkClick}
                >
                  Conexiones
                </Link>
              </li>
            )}

            {/* DROPDOWN DE USUARIO / LOGIN */}
            <li className="dropdown">
              {user ? (
                <>
                  <Link to='#' className='header__user-dropdown'>
                    <span>{user.full_name}</span> <i className="bi bi-chevron-down"></i>
                  </Link>
                  <ul>
                    <li><Link to='/perfil' onClick={handleNavLinkClick}>Mi Perfil</Link></li>
                    <li><Link to='/empresa' onClick={handleNavLinkClick}>Mi Empresa</Link></li>
                    <li><Link to='#' onClick={handleLogout}>Salir</Link></li>
                  </ul>
                </>
              ) : (
                <Link to='/login' className='header__login-button' onClick={handleNavLinkClick}>
                  Iniciar Sesión
                </Link>
              )}
            </li>
          </ul>
          <i className="bi bi-list mobile-nav-toggle"></i>
        </nav>
      </div>
    </header>
  );
}

export default Header;